import { LocationData } from "../types/location";

export const generateAddress = (
  locationData: LocationData,
  options?: { format?: "full" | "nameAddressZip" }
) => {
  return [
    locationData.addressee,
    locationData.addressLine?.trim(),
    [
      options?.format === "nameAddressZip"
        ? undefined
        : locationData.city?.trim(),
      [
        options?.format === "nameAddressZip"
          ? undefined
          : locationData.state?.trim(),
        locationData.zip?.trim(),
      ]
        .filter((a) => !!a)
        .join(" "),
      options?.format === "nameAddressZip"
        ? undefined
        : locationData.countryCode?.trim(),
    ]
      .filter((a) => !!a)
      .join(", "),
  ].filter((a) => !!a).join(`
`);
};

export const generateAddressElement = (
  locationData: LocationData,
  options?: { format?: "full" | "nameAddressZip" }
) => {
  return [
    locationData.addressee,
    locationData.addressLine?.trim(),
    [
      options?.format === "nameAddressZip"
        ? undefined
        : locationData.city?.trim(),
      [
        options?.format === "nameAddressZip"
          ? undefined
          : locationData.state?.trim(),
        locationData.zip?.trim(),
      ]
        .filter((a) => !!a)
        .join(" "),
      options?.format === "nameAddressZip"
        ? undefined
        : locationData.countryCode?.trim(),
    ]
      .filter((a) => !!a)
      .join(", "),
  ]
    .filter((a) => !!a)
    .map((address) => (
      <span key={address}>
        {address}
        <br />
      </span>
    ));
};
